// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Menu from 'components/menu/menu'

// Redux:
import { getPageData } from 'actions/page'

const logoTextSVG = safeSiteData.images_url + 'logo/safe.svg'
const logoTextPNG = safeSiteData.images_url + 'logo/safe.png'

const siteName = safeSiteData.site_name
const siteURL = safeSiteData.site_url
const siteImage = safeSiteData.site_featured_image_url
const siteImageSrcset = safeSiteData.site_featured_image_srcset

class HeaderPrimary extends React.Component {
	handleMenuItemHover = ( e ) => {
		// this.props.getPost( 'donate' )
	}

	render() {
		return (
			<header className="header">
				<div className="header-top">
					<div className="logo">
						<Link to="/">
							<img className="site-logo" src={ logoTextPNG } alt="" />
						</Link>
					</div>

					<div className="-social">
						<a href="https://www.facebook.com/SAFEpetsAU/" target="_blank" rel="noopener">
							<span className="u-screen-reader-text">Facebook</span>
							<i className="icon-facebook-square" arua-hidden="true"></i>
						</a>

						<a href="https://www.instagram.com/safe_inc/" target="_blank" rel="noopener">
							<span className="u-screen-reader-text">Instagram</span>
							<i className="icon-instagram" arua-hidden="true"></i>
						</a>

						<a href="https://www.youtube.com/channel/UCvbgZD9Up_bbEX4WdPevpoQ" target="_blank" rel="noopener">
							<span className="u-screen-reader-text">YouTube</span>
							<i className="icon-youtube-square" arua-hidden="true"></i>
						</a>

						<a className="is-google-bus" href="https://www.google.com/search?q=Saving+Animals+from+Euthanasia+Inc.+(SAFE+Inc)&stick=H4sIAAAAAAAA_-NgU1I1qDBKSjMzNDVKM01LMzQ0sEixAgqlWqSaGqYkp1qaGpgYGKcuYtULTizLzEtXcMzLzE3MKVZIK8rPVXAtLclIzEsszkxU8MxL1lPQCHZ0cwUxNQGjDsluWgAAAA&hl=en-GB&mat=CQoy_eg1Ow_AElcB7PxHsQXBonIcxF4MXpO4n_7DUb6ON6sGWe31vHdlBP1z7kIDhgXJgupnd08_fkJ5P2uz1rNme3IVub026Gku34ROLJ5Pg7czxwS-5PffDMpa-lXzvOY&authuser=0&ved=2ahUKEwj3-bDXs5aFAxVPTWwGHbXtAdUQ-MgIegQIFRAd" target="_blank" rel="noopener">
							<span className="u-screen-reader-text">Google Business</span>
							<img src={ `${safeSiteData.images_url}icons/google-my-business.svg` } alt="" />
						</a>
					</div>

					<Link to="/donate" className="button" onMouseOver={ this.handleMenuItemHover }>Donate</Link>
					<a href="https://www.safewa.org.au/" className="button" target="_blank" rel="noopener">Shop</a>
				</div>

				<Menu />
			</header>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getPost: ( slug ) => {
			dispatch( getPageData( slug, 'page', false, true ) )
		},
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( HeaderPrimary )



// WEBPACK FOOTER //
// ./components/header-primary/header-primary.jsx